import React, {HTMLAttributes} from "react";
import {Grid, Typography} from "@leap4/frontend";
import {IAdServerTagTotals, IDiscrepancy, IPublisherTagTotals} from "@leap4/entities-discrepancy-common";
import * as _ from "lodash";
import {ScrapingUtils} from "../../../../utils/scraping.utils";
import PercentCell from "../../../shared/PercentCell/PercentCell";
import {renderValue} from "../renderValues";

interface IProps extends HTMLAttributes<HTMLDivElement> {
    discrepancy: IDiscrepancy,
    publisherTotals: IPublisherTagTotals,
    adServersTotals: IAdServerTagTotals,
    onClick?: any
    lastMetricTime?: string | Date
    subtitle?: string,
    title?: string

}

export default function Index({
                                  discrepancy,
                                  publisherTotals,
                                  adServersTotals,
                                  onClick,
                                  lastMetricTime,
                                  subtitle,
                                  title,
                                  ...htmlAttributes
                              }: IProps) {
    const METRICS_NAMES = ["revenue", "impressions"]
    const constantGap = '10px'
    const showDiff = publisherTotals && adServersTotals;

    return (
        <Grid container direction={"column"} alignContent={"center"} style={{padding: '15px'}} {...htmlAttributes}>
            <Grid item xs={12} md={12}>
                { title &&   <Typography variant="h5"> {title} </Typography> }
                { subtitle && <Typography variant="h6"> {subtitle}</Typography> }
            </Grid>
            {!showDiff && "No Diff to show"}
            {showDiff && (
                <Grid item width={"100%"}>
                    <Grid container gap={constantGap} padding={"0 15px"} height={"100%"} justifyContent="center" mt={3}>
                        <Grid item mr="25%">

                            <Grid container direction="column" gap={constantGap} height="99%" justifyContent="center">
                                <Grid item>
                                    <Typography variant={"button"}>
                                        Publisher
                                    </Typography>
                                </Grid>
                                <Grid item>VS</Grid>
                                <Grid item>
                                    <Typography variant={"button"}>
                                        AdServer
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        {
                            METRICS_NAMES.map(metric => (
                                <Grid item key={metric}>
                                    <Typography variant="button" component="h6" style={{fontWeight: 600}}>
                                        {metric}
                                    </Typography>
                                    <div style={{margin: '2px 5px'}}>
                                        {renderValue(publisherTotals[metric], metric)}
                                    </div>
                                    <PercentCell percent={discrepancy[metric]?.percent}/>
                                    <span> {renderValue(discrepancy[metric].value, metric)}</span>
                                    {renderValue(adServersTotals[metric], metric)}

                                </Grid>
                            ))
                        }
                    </Grid>
                </Grid>
            )}
        </Grid>
    )


}